import React from 'react'
import { CountryCode } from '@carsys/enums/country-code'
import { Locales } from '@carsys/enums/locales'
import currencyData from './CurrencyData'

export const LocaleContext = React.createContext({
  locale: Locales.nl_NL,
  country: CountryCode.NL,
  currencySymbol: currencyData[CountryCode.NL].symbol,
  formatter: new Intl.NumberFormat(Locales.nl_NL, { style: 'currency', currency: currencyData[CountryCode.NL].currency }),
  formatterNoCurrency: new Intl.NumberFormat(Locales.nl_NL, {
    style: 'decimal',
    currency: currencyData[CountryCode.NL].currency
  }),
  hasBeenProvided: false
})

interface Props {
  locale: Locales
  country: CountryCode
}

export const LocaleContextProvider: React.FC<Props> = React.memo(({ children, country, locale }) => {
  const value = React.useMemo(() => {
    const { currency, symbol } = currencyData[country]
    return {
      hasBeenProvided: true,
      locale,
      country,
      currencySymbol: symbol,
      formatter: new Intl.NumberFormat(!locale || locale === Locales.development ? Locales.nl_NL : locale, { style: 'currency', currency }),
      formatterNoCurrency: new Intl.NumberFormat(!locale || locale === Locales.development ? Locales.nl_NL : locale, {
        style: 'decimal',
        currency
      })
    }
  }, [country, locale])

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
})

export const { Consumer: LocaleContextConsumer } = LocaleContext

/**
 * useLocaleContext contains all the locale information
 * @returns
 */
export const useLocaleContext = () => {
  const context = React.useContext(LocaleContext)
  if (context === undefined || !context?.hasBeenProvided) {
    throw new Error('useLocaleContext must be used within a LocaleContextProvider and hasBeenProvided must be set')
  }
  return context
}
